import servicePhotoUrl from "assets/more-services.jpg";

export const serviceCardsExampleData = [
  {
    photo: servicePhotoUrl,
    heading: "Logo & brand identity pack",
    description: "The perfect logo plus custom business card, stationery and Facebook cover designs",
    price: 599,
    saving: 79
  },
  {
    photo: servicePhotoUrl,
    heading: "Logo & brand identity pack",
    description: "The perfect logo plus custom business card, stationery and Facebook cover designs",
    price: 599,
    saving: 79
  }
];
